import React, { useState } from "react";
import { FaMapMarkerAlt } from "react-icons/fa";
import styles from "./ContactUsMap.module.scss";

const ContactUsMap = () => {
	const [mapLoaded, setMapLoaded] = useState(false);

	return (
		<div className={styles.ContactUsMap}>
			<div className={styles.Left}>
				<h2>Visit Us</h2>
				<h3>MINE KIDS PRE SCHOOL & CRECHE</h3>
				<div className={styles.Content}>
					<div className={styles.L}>
						<h4>Baramunda Branch</h4>
						<p>MDL-7, Shanti Vihar,</p>
						<p>H.B Colony Baramunda,</p>
						<p>Bhubaneswar</p>
					</div>
					<div className={styles.R}>
						<h4>Patrapada Branch</h4>
						<p>Plot No- 275, Bhagabanpur,</p>
						<p>Near Banyan Courtyard,</p>
						<p>Patrapada, Bhubaneswar</p>
					</div>
				</div>
			</div>
			<div className={styles.Right}>
				{!mapLoaded && (
					<div className={styles.MapSkeleton}>
						<div className={styles.SkeletonIcon}>
							<FaMapMarkerAlt />
						</div>
						<div className={styles.SkeletonText}></div>
						<div className={styles.SkeletonSubtext}></div>
					</div>
				)}
				<iframe
					src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14969.923930721237!2d85.7865992!3d20.280349!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a190827563ae50b%3A0xa635de87d04d9ab6!2sMine%20Kids%20Preschool%20%26%20Creche!5e0!3m2!1sen!2sin!4v1688293127108!5m2!1sen!2sin"
					width="100%"
					height="100%"
					allowFullScreen="none"
					loading="lazy"
					referrerPolicy="no-referrer-when-downgrade"
					title="Google Maps Location"
					onLoad={() => setMapLoaded(true)}
					style={{
						opacity: mapLoaded ? 1 : 0,
						transition: "opacity 0.4s ease-in-out",
						display: "block",
					}}></iframe>
			</div>
		</div>
	);
};

export default ContactUsMap;
